import { PhysicianProcedure } from 'app/core/dtos/physician.dto';
import { User } from 'app/core/models/user.model';

export enum PaymentStatus {
  PENDING = 'pending',
  FAILED = 'failed',
  PAID = 'paid',
  CANCELED = 'canceled',
  REFUSED = 'refused',
  REVERSED = 'reversed',
}

export interface AppointmentDTO {
  customerId: string;
  datetime: Date;
  physicianId: string;
  address: string;
  status: string;
  couponId: string;
  userAddressId: string;
  CRO: string;
}

export interface CouponDTO {
  id: string;
  ownerId: string;
  ownerName: string;
  ownerCpf: string;
  ownerBirthDate: string;
  expirationDays: number;
  remainingDays: number;
  createdAt: Date;
  expireAt: Date;
  isExpired: boolean;
  isAssigned: boolean;
  isRedeemed: boolean;
}

export interface PaymentDTO {
  id: string;
  status: string;
  price: number;
  ownerId: string;
  ownerName: string;
  ownerCpf: string;
  ownerBirthDate: string;
  createdAt: Date;
}

export interface AppointmentPurchaseDetailsResponseDTO {
  customer: User;
  physician: User;
  appointment: AppointmentDTO;
  coupon?: CouponDTO;
  payment?: PaymentDTO;
  procedures?: PhysicianProcedure[];
  paymentLink?: string;
  couponQRCodeBase64?: string;
}
